<template lang="pug">
   section.heading-field(:class="classes" :style="style")
        .wrap(:class="[textAlignment]")
            component(v-if="subHeading", :is="subHeadingTag", :class="classes.subHeading") {{ subHeading }}
            component(v-if="heading", :is="headingTag", :class="classes.heading") {{ heading }}
</template>

<script>
// import _ from 'lodash'
import get from 'lodash.get';
import section from '@/mixins/section';

export default {
    name: 'Heading',
    mixins: [section],
    props: {
        section: {
            type: Object,
            required: true
        },
        headingTag: {
            type: String,
            default: 'h2'
        },
        headingClass: {
            type: String,
            default: 'title regular'
        },
        subHeadingTag: {
            type: String,
            default: 'h3'
        },
        subHeadingClass: {
            type: String,
            default: 'subtitle regular'
        }
    },
    computed: {
        heading() {
            return get(this.section, 'contents.0.title');
        },
        subHeading() {
            return get(this.section, 'contents.0.sub_title');
        },
        textAlignment() {
            let alignment = 'text-center';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'text_alignment');
                if (setting && setting.value !== undefined) alignment = setting.value;
            }

            return alignment;
        },

        classes() {
            let classes = {
                heading: this.headingClass,
                subHeading: this.subHeadingClass,
            };

            const settings = get(this.section.contents[0], 'settings') || [];
            const titleSize = settings.find(setting => setting.key === 'title_size');
            const subTitleSize = settings.find(setting => setting.key === 'sub_title_size');

            if (titleSize && titleSize.value !== undefined) {
                switch (titleSize.value) {
                    case 'small':
                        classes.heading = 'title small';
                        break;
                    
                    case 'large':
                        classes.heading = 'title large';
                        break;

                    case 'regular':
                    default:
                        classes.heading = 'title regular';

                   
                }
            }

            if (subTitleSize && subTitleSize.value !== undefined) {
                switch (subTitleSize.value) {
                    case 'small':
                        classes.subHeading = 'subtitle small';
                        break;

                    case 'large':
                        classes.subHeading = 'subtitle large';
                        break;

                    case 'regular':
                    default:
                        classes.subHeading = 'subtitle regular';
                }
            }

            return classes;
        }
    }
};
</script>

<style lang="sass" scoped>
.heading-field
  @apply px-16
  .wrap
    @screen md
        //@apply mx-8
  h2,h3
    @apply inline-block
  .title
    @apply font-bold
    color: var(--color-primary)
  .subtitle
    @apply pr-2

  // SIZES
  .small
    @apply text-lg
  .regular
    @apply text-xl
  .large
    @apply text-2xl
</style>
